import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/views/home';

// import { ApmVuePlugin } from '@elastic/apm-rum-vue'

const asiSomos = () => import('@/components/views/asi-somos');
const queOfrecemos = () => import('@/components/views/que-ofrecemos');
const tarifasLuz = () => import('@/components/views/tarifas-luz');
const tarifasGas = () => import('@/components/views/tarifas-gas');
const tarifasGasEmpresa = () => import('@/components/views/tarifas-gas-empresa');
const tarifasLuzyGas = () => import('@/components/views/tarifas-luz-y-gas');
const inergizate = () => import('@/components/views/inergizate');
const franquicia = () => import('@/components/views/franquicia');
const preguntasFrecuentes = () => import('@/components/views/preguntas-frecuentes');
const ofrecemosMuchoMas = () => import('@/components/views/ofrecemos-mucho-mas');
const simulador = () => import('@/components/views/simulador');

const autoconsumo = () => import('@/components/views/autoconsumo/autoconsumo');
const autoconsumoconiner = () => import('@/components/views/autoconsumo/autoconsumo-con-iner');
const autoconsumoayudamos = () => import('@/components/views/autoconsumo/te-ayudamos');
const landingautoconsumo = () => import('@/components/views/autoconsumo/landing');
const autoconsumotarifas = () => import('@/components/views/autoconsumo/tarifas');
const calculoautoconsumo = () => import('@/components/views/autoconsumo/calculo');
const condicionespago = () => import('@/components/views/autoconsumo/condiciones-pago');
const mapa_autoconsumo = () => import('@/components/views/autoconsumo/mapa');

const promociones = () => import('@/components/views/promociones');
const fichaPromociones = () => import('@/components/views/ficha-promociones');

const Blog = () => import('@/components/views/blog');
const FichaNoticia = () => import('@/components/views/ficha-noticia');

const firmaContrato = () => import('@/components/views/firma-contrato');

const firmaOK = () => import('@/components/views/ok-firma');
const peticionContratoOK = () => import('@/components/views/ok-peticion-contrato');

const Contacto = () => import('@/components/views/contacto');
const TrabajaConNosotros = () => import('@/components/views/trabaja-con-nosotros');

const empresas = () => import('@/components/views/empresas/empresas');
const teayudamos = () => import('@/components/views/empresas/te-ayudamos');
const luzempresas = () => import('@/components/views/empresas/tarifas-luz');

const Error404 = () => import('@/components/views/error-404');

const politicaCookies = () => import('@/components/views/politica-de-cookies');
const politicaPrivacidad = () => import('@/components/views/politica-de-privacidad');
const avisoLegal = () => import('@/components/views/aviso-legal');
const terminos = () => import('@/components/views/terminos-y-condiciones');

const condicionesdelcontrato = () => import('@/components/views/condiciones-del-contrato');
import aerotermia from '@/components/views/aerotermia';
import cocheElectrico from '@/components/views/coche-electrico';
Vue.use(Router)


import messages from '@/translations';

let es = messages.es.enlaces;
let seo = messages.es.seo

const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home,
			meta: {
				seo: seo.home,
				image: 'home',
				parentMenu: 'general'
			}
		},
		{
			path: es.que_ofrecemos,
			name: 'que-ofrecemos',
			component: queOfrecemos,
			meta: {
				seo: seo.que_ofrecemos,
				image: 'que-ofrecemos',
				parentMenu: 'general'
			}
		},
		{
			path: `${es.ofrecemosMuchoMas}/:id?`,
			name: 'ofrecemos-mucho-mas',
			component: ofrecemosMuchoMas,
			meta: {
				seo: seo.ofrecemosMuchoMas,
				image: 'mucho-mas'
			}
		},
		{
			path: `/luz/hogar`,
			name: 'tarifas-luz',
			component: tarifasLuz,
			meta: {
				type: 'tarifa',
				seo: seo.tarifas_luz,
				image: 'tarifas-luz',
				parentMenu: 'luz'
			}
		},
		{
			path: `/gas/hogar`,
			name: 'tarifas-gas',
			component: tarifasGas,
			meta: {
				type: 'tarifa',
				seo: seo.tarifas_gas,
				image: 'tarifas-gas',
				parentMenu: 'gas'

			}
		},
		{
			path: `/gas/empresa`,
			name: 'tarifas-gas-empresa',
			component: tarifasGasEmpresa,
			meta: {
				type: 'tarifa',
				seo: seo.tarifas_gas,
				image: 'tarifas-gas',
				parentMenu: 'gas'
			}
		},
		{
			path: `/aerotermia`,
			name: 'aerotermia',
			component: aerotermia,
			meta: {
				type: 'aerotermia',
				seo: seo.aerotermia,
				image: 'aerotermia',
				parentMenu: 'aerotermia'
			}
		},
		{
			path: `/coche-electrico`,
			name: 'cocheElectrico',
			component: cocheElectrico,
			meta: {
				type: 'coche-electrico',
				seo: seo.cocheElectrico,
				image: 'coche-electrico',
				parentMenu: 'coche-electrico'
			}
		},
		{
			path: `${es.tarifas}/luz-y-gas`,
			name: 'tarifas-luz-y-gas',
			component: tarifasLuzyGas,
			meta: {
				type: 'tarifa',
				seo: seo.tarifas_luzgas,
				image: 'tarifas-luz-y-gas'
			}
		},
		{
			path: `${es.inergizate}/:idtarifa?/:paso?`,
			name: 'inergizate',
			component: inergizate,
			meta: {
				seo: seo.inergizate,
				image: 'inergizate'
			}
		},
		{
			path: es.franquicia,
			name: 'franquicia',
			component: franquicia,
			meta: {
				seo: seo.franquicia
			}
		},
		{
			path: `${es.preguntas_frecuentes}/:cat?/:id?`,
			name: 'preguntas-frecuentes',
			component: preguntasFrecuentes,
			meta: {
				seo: seo.preguntas_frecuentes,
				image: 'preguntas-frecuentes'
			}
		},
		{
			path: es.promociones,
			name: 'promociones',
			component: promociones,
			meta: {
				seo: seo.promociones,
				image: 'blog'
			}
		},
		{
			path: `${es.promociones}/:id`,
			name: 'ficha-promociones',
			component: fichaPromociones
		},
		{
			path: es.asi_somos,
			name: 'asi-somos',
			component: asiSomos,
			meta: {
				seo: seo.asi_somos,
				image: 'asi-somos',
				parentMenu: 'general'
			}
		},
		{
			path: `${es.simulador}/:paso?`,
			name: 'simulador',
			component: simulador,
			meta: {
				seo: seo.simulador,
				image: 'simulador',
				hidellamame: true
			}
		},
		{
			path: es.firma_contrato,
			name: 'firma-contrato',
			component: firmaContrato,
			meta: {
				hidellamame: true
			}
		},
		{
			path: es.okfirma,
			name: 'contrato-firmado',
			component: firmaOK,
			meta: {
				hidellamame: true
			}
		},
		{
			path: es.contratoSolicitado,
			name: 'contrato-solicitado',
			component: peticionContratoOK
		},
		{
			path: es.blog,
			name: 'blog',
			component: Blog,
			meta: {
				seo: seo.blog,
				image: 'blog',
				hidellamame: true
			}
		},
		{
			path: `${es.blog}/:id`,
			name: 'blog-ficha',
			component: FichaNoticia,
			meta: {
				hidellamame: true
			}
		},
		{
			path: `${es.bases_legales}/:id`,
			name: 'bases-ficha',
			component: FichaNoticia,
			meta: {
				hidellamame: true
			}
		},
		{
			path: es.contacto,
			name: 'contacto',
			component: Contacto,
			meta: {
				seo: seo.contacto,
				image: 'contacta'
			}
		},
		{
			path: es.empresas,
			name: 'empresas',
			component: empresas,
			meta: {
				seo: seo.empresas,
				image: 'empresas',
				inempresas: true,
			}
		},
		{
			path: es.teayudamos,
			name: 'te-ayudamos',
			component: teayudamos,
			meta: {
				seo: seo.empresasayudamos,
				image: 'empresas',
				inempresas: true
			}
		},
		{
			path: es.luzempresas,
			name: 'tarifa-luz-empresas',
			component: luzempresas,
			meta: {
				seo: seo.tarifasempresas,
				image: 'empresas',
				inempresas: true,
				parentMenu: 'luz'
			}
		},
		{
			path: es.autoconsumo,
			redirect: `${es.autoconsumo}/particulares`
		},
		{
			path: `${es.autoconsumo}/particulares`,
			alias: `${es.autoconsumo}/particulares`,
			name: 'autoconsumo-particulares',
			component: autoconsumo,
			meta: {
				seo: seo.autoconsumo,
				image: 'autoconsumo',
				inautoconsumo: true
			}
		},
		{
			path: `${es.autoconsumo}/empresas`,
			alias: `${es.autoconsumo}/empresas`,
			name: 'autoconsumo-empresas',
			component: autoconsumo,
			meta: {
				seo: seo.autoconsumo,
				image: 'autoconsumo',
				inautoconsumo: true
			}
		},
		{
			path: `${es.autoconsumo}/agricultura`,
			alias: `${es.autoconsumo}/agricultura`,
			name: 'autoconsumo-agricultura',
			component: autoconsumo,
			meta: {
				seo: seo.autoconsumo,
				image: 'autoconsumo',
				inautoconsumo: true
			}
		},
		{
			path: es.condiciones_autoconsumo,
			name: 'condicionespago',
			component: condicionespago,
			meta: {
				seo: seo.autoconsumo,
				image: 'autoconsumo',
				inautoconsumo: true
			}
		},
		{
			path: es.autoconsumo_iner,
			name: 'autoconsumoconiner',
			component: autoconsumoconiner,
			meta: {
				seo: seo.autoconsumo_iner,
				image: 'autoconsumo',
				inautoconsumo: true
			}
		},
		{
			path: es.autoconsumo_ayudamos,
			name: 'autoconsumoayudamos',
			component: autoconsumoayudamos,
			meta: {
				seo: seo.autoconsumo_ayudamos,
				image: 'autoconsumo',
				inautoconsumo: true
			}
		},
		{
			path: es.landing_autoconsumo,
			name: 'landingautoconsumo',
			component: landingautoconsumo,
			meta: {
				seo: seo.autoconsumo,
				image: 'autoconsumo',
				inautoconsumo: true
			}
		},
		{
			path: es.mapa_autoconsumo,
			name: 'mapa-autoconsumo',
			component: mapa_autoconsumo,
			meta: {
				seo: seo.autoconsumo,
				image: 'autoconsumo',
				inautoconsumo: true
			}
		},
		{
			path: `${es.calculo_autoconsumo}/:id?`,
			name: 'calculo_autoconsumo',
			component: calculoautoconsumo,
			meta: {
				seo: seo.calculo_autoconsumo,
				image: 'autoconsumo',
				inautoconsumo: true,
			}
		},
		{
			path: `${es.autoconsumo_tarifas}/:type?`,
			name: 'autoconsumotarifas',
			component: autoconsumotarifas,
			meta: {
				seo: seo.autoconsumo_tarifas,
				image: 'autoconsumo',
				inautoconsumo: true
			}
		},
		{
			path: es.politica_privacidad,
			name: 'politica-de-privacidad',
			component: politicaPrivacidad,
			meta: {
				seo: seo.politica_privacidad
			}
		},
		{
			path: es.politica_cookies,
			name: 'politica-de-cookies',
			component: politicaCookies,
			meta: {
				seo: seo.politica_cookies
			}
		},
		{
			path: es.condiciones_contrato,
			name: 'condiciones-del-contrato',
			component: condicionesdelcontrato,
			meta: {
				seo: seo.condiciones_contrato
			}
		},
		{
			path: es.aviso_legal,
			name: 'aviso-legal',
			component: avisoLegal,
			meta: {
				seo: seo.aviso_legal
			}
		},
		{
			path: es.terminos_y_condiciones,
			name: 'terminos-y-condiciones',
			component: terminos,
			meta: {
				seo: seo.terminos_y_condiciones
			}
		},
		// { path: '*', redirect: '/' },
		//REDIRECCIONES ANTIGUAS
		{ path: '/quienes-somos-iner-energia-castilla-la-mancha', redirect: es.asi_somos },
		{ path: '/solicitar-informacion', redirect: es.contacto },
		{ path: '/productos-hogar/', redirect: es.que_ofrecemos },
		{ path: '/iner-hogar/', redirect: es.que_ofrecemos },
		{ path: '/iner-gas/', redirect: es.que_ofrecemos },
		{ path: '/tarifas/', redirect: es.que_ofrecemos },
		{ path: '/iner-pymes/', redirect: es.empresas },
		{ path: '/politica-de-privacidad-y-aviso-legal/', redirect: es.aviso_legal },


	],
	scrollBehavior(to, from, savedPosition) {

		let dontmove = ['preguntas-frecuentes', 'simulador', 'inergizate'];

		if (savedPosition) {
			return savedPosition
		} else {
			if (!dontmove.some(r => r == to.name)) {
				return { x: 0, y: 0 }
			} else if (!dontmove.some(r => r == from.name)) {
				return { x: 0, y: 0 }
			}
		}
	},
});
import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
	config: { id: "AW-692816998" }
});

router.beforeEach((to, from, next) => {

	if (!!to.meta) {
		if (!!to.meta.seo) {
			document.title = to.meta.seo.title;
			document.head.querySelector("[name=description]").content = to.meta.seo.description;
			document.head.querySelector("[property='og:title']").content = to.meta.seo.title;
			document.head.querySelector("[name='twitter:title']").content = to.meta.seo.title;
			document.head.querySelector("[property='og:description']").content = to.meta.seo.description;
			document.head.querySelector("[name='twitter:description']").content = to.meta.seo.description;
		}

		if (!!to.meta.image) {
			                    document.head.querySelector("[property='og:image']").content = location.origin + '/static/img/rrss/' + to.meta.image + '.webp';
			document.head.querySelector("[name='twitter:image']").content = location.origin + '/static/img/rrss/' + to.meta.image + '.webp';
		}
	}



	//SIRVE PARA QUITAR EL BLOQUEO DE SCROLL DE LA FIRMA
	if (from.name == 'firma-contrato') {
		$("html").removeClass('no-scroll');
	}

	next()
});

export default router;




// WEBPACK FOOTER //
// ./src/router/index.js